import React, { Component } from 'react';
import api from '../api';
import { toast } from 'react-toastify';
import store from "../redux/store";
import CompanyProfile from '../custom-components/cform/companys-profile';
import DirectorData1 from '../custom-components/cform/directors-data1';
import DirectorData2 from '../custom-components/cform/directors-data2';
import DirectorData3 from '../custom-components/cform/directors-data3';
import AuthorizedSignatory1 from '../custom-components/cform/authorized-signatory1';
import AuthorizedSignatory2 from '../custom-components/cform/authorized-signatory2';
import AuthorizedSignatory3 from '../custom-components/cform/authorized-signatory3';
import InvestmentDetails from '../custom-components/cform/investment-details';
import BankDetails from '../custom-components/cform/bank-details';
import Confirmation from '../custom-components/cform/confirmation';
import { Header } from '../custom-components/header';
import loadScripts from '../../dassets/js/custom';

export default class CreateCForms extends Component {
  componentDidMount() {
    loadScripts();
  }
    constructor(props) {
        super(props);

        // this.onChangeFiles = this.onChangeFiles.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.sendCForm = this.sendCForm.bind(this);
        this.saveValues = this.saveValues.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.previousStep = this.previousStep.bind(this);

        this.state = {
            step: 1
        }

        this.fieldValues = {
            type: "corporate",
            company_name: null,
            reg_no: null,
            address: null,
            nature_of_business: null,
            telephone: null,
            id_no: null,
            email: null,
            affiliations: null,
            date_of_incorporation: null,
            annual_turnover: null,
            passport_path: null,
            director_data: [
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    res_add: null,
                    id_means: null,
                    phone: null,
                    bvn: null,
                    signature_path: null
                },
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    res_add: null,
                    id_means: null,
                    phone: null,
                    bvn: null,
                    signature_path: null
                },
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    res_add: null,
                    id_means: null,
                    phone: null,
                    bvn: null,
                    signature_path: null
                },
            ],
            authorized_signatory: [
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    res_add: null,
                    id_means: null,
                    phone: null,
                    designation: null,
                    signature_path: null
                },
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    res_add: null,
                    id_means: null,
                    phone: null,
                    designation: null,
                    signature_path: null
                },
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    res_add: null,
                    id_means: null,
                    phone: null,
                    designation: null,
                    signature_path: null
                },
            ],
            bank_name: null,
            acct_name: null,
            acct_no: null,
            acct_type: null,
            opening_date: null,
            bvn: null,
            initial_investment: null,
            mode_of_payment: null,
            mode_of_communication: null,
            investment_objective: null,
            prefered_account: null,
            heard_about_us: [],
            kyc_docs: [{ label: "Company's Utility Bill", value: "Company's Utility Bill" }],
            receive_reports: [],
        }
    }

    saveValues(fields, key = null, index = 0) {
        if (!key) {
            this.fieldValues = Object.assign({}, this.fieldValues, fields);
        } else {
            this.fieldValues[key][index] = fields;
        }
    }

    nextStep() {
        this.setState({
            step: this.state.step + 1
        })
    }

    // Same as nextStep, but decrementing
    previousStep() {
        this.setState({
            step: this.state.step - 1
        })
    }

    async onSubmit() {
        let i = 0;
        this.fieldValues.kyc_docs.find(o => {
            if (o.name === "Company's Utility Bill") {
                i++;
            }
        });

        if(this.fieldValues.kyc_docs.some(r=> ["Certificate of Incorporation","C.A.C Form 2","C.A.C Form 7","Memorandum and Articles of Association","Board Resolution","Means of ID of Director's and Authorized Signatory"].includes(r.name))){
            i++;
        }

        if (i < 2) {
            toast.error("You need to upload Company's Utility Bill and one other document");
            return
        }

        this.fieldValues.kyc_docs = JSON.stringify(this.fieldValues.kyc_docs);
        this.fieldValues.heard_about_us = this.fieldValues.heard_about_us.toString();
        this.fieldValues.receive_reports = this.fieldValues.receive_reports.toString();

        const formData = new FormData();
        let fno = 0;
        if (this.fieldValues.passport) {
            formData.append(`file${fno}`, this.fieldValues.passport, this.fieldValues.passport_path);
            fno++;
        }
        if (this.fieldValues.director_data[0].signature) {
            formData.append(`file${fno}`, this.fieldValues.director_data[0].signature, this.fieldValues.director_data[0].signature_path);
            fno++;
        }
        if (this.fieldValues.director_data[1].signature) {
            formData.append(`file${fno}`, this.fieldValues.director_data[1].signature, this.fieldValues.director_data[1].signature_path);
            fno++;
        }
        if (this.fieldValues.director_data[2].signature) {
            formData.append(`file${fno}`, this.fieldValues.director_data[2].signature, this.fieldValues.director_data[2].signature_path);
            fno++;
        }
        if (this.fieldValues.authorized_signatory[0].signature) {
            formData.append(`file${fno}`, this.fieldValues.authorized_signatory[0].signature, this.fieldValues.authorized_signatory[0].signature_path);
            fno++;
        }
        if (this.fieldValues.authorized_signatory[1].signature) {
            formData.append(`file${fno}`, this.fieldValues.authorized_signatory[1].signature, this.fieldValues.authorized_signatory[1].signature_path);
            fno++;
        }
        if (this.fieldValues.authorized_signatory[2].signature) {
            formData.append(`file${fno}`, this.fieldValues.authorized_signatory[2].signature, this.fieldValues.authorized_signatory[2].signature_path);
            fno++;
        }
        formData.append('file_no', this.fieldValues.documents.length + fno);
        this.fieldValues.documents.forEach((doc, i) => {
            formData.append(`file${i + fno}`, doc.file, doc.path);
        });
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        await api.post(`/forms/corporate/upload`, formData, config,)
            .then(res => {
                console.log("Image uploaded successfully");
            }).catch(error => {
                let err = store.getState().error;
                if (err) {
                    toast.error(err.message);
                    this.props.history.push(err.redirectUrl)
                }
                console.log(error)
            });

        this.sendCForm();
    }

    sendCForm() {

        api.post(`/forms/corporate`, this.fieldValues)
            .then(res => {
                toast.success("Thanks for taking time to submit your details, we will contact you via email.");
                this.props.history.push(`/`)
            }).catch(error => {
                let err = store.getState().error;
                if (err) {
                    toast.error(err.message);
                    this.props.history.push(err.redirectUrl)
                }
                console.log(error)
            });
    }

    render() {
        switch (this.state.step) {
            case 1:
                return <section><Header name="Corporate Account Opening Form" step={this.state.step} max="10"/><CompanyProfile fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    saveValues={this.saveValues} /></section>
            case 2:
                return <section><Header name="Corporate Account Opening Form" step={this.state.step} max="10"/><DirectorData1 fieldValues={this.fieldValues.director_data[0]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 3:
                return <section><Header name="Corporate Account Opening Form" step={this.state.step} max="10"/><DirectorData2 fieldValues={this.fieldValues.director_data[1]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 4:
                return <section><Header name="Corporate Account Opening Form" step={this.state.step} max="10"/><DirectorData3 fieldValues={this.fieldValues.director_data[2]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 5:
                return <section><Header name="Corporate Account Opening Form" step={this.state.step} max="10"/><BankDetails fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 6:
                return <section><Header name="Corporate Account Opening Form" step={this.state.step} max="10"/><InvestmentDetails fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 7:
                return <section><Header name="Corporate Account Opening Form" step={this.state.step} max="10"/><AuthorizedSignatory1 fieldValues={this.fieldValues.authorized_signatory[0]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 8:
                return <section><Header name="Corporate Account Opening Form" step={this.state.step} max="10"/><AuthorizedSignatory2 fieldValues={this.fieldValues.authorized_signatory[1]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 9:
                return <section><Header name="Corporate Account Opening Form" step={this.state.step} max="10"/><AuthorizedSignatory3 fieldValues={this.fieldValues.authorized_signatory[2]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 10:
                return <section><Header name="Corporate Account Opening Form" step={this.state.step} max="10"/><Confirmation fieldValues={this.fieldValues}
                    submit={this.onSubmit}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            default:

        }
    }
}